export enum ECheckoutStatus {
  Initial = 'Initial',
  Success = 'Success',
  Failed = 'Failed',
  SuccessFromOrderInfo = 'SuccessFromOrderInfo',
  SuccessFromBillingInfo = 'SuccessFromBillingInfo',
  SuccessFromPatientInfo = 'SuccessFromPatientInfo',
  SuccessFromClinicalInfo = 'SuccessFromClinicalInfo',
  SuccessFromConsentInfo = 'SuccessFromConsentInfo',
  SuccessFromConfirmOrder = ' SuccessFromConfirmOrder',
  ErrorFromOrderInfo = 'ErrorFromOrderInfo',
  ErrorFromBillingInfo = 'ErrorFromBillingInfo',
  ErrorFromPatientInfo = 'ErrorFromPatientInfo',
  ErrorFromClinicalInfo = 'ErrorFromClinicalInfo',
  ErrorFromConsentInfo = 'ErrorFromConsentInfo',
  ErrorFromConfirmOrder = 'ErrorFromConfirmOrder',
}
